import React from 'react';

const ORGicon = () => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.5 8.1665V3.1665L8 0.666504L5.5 3.1665V4.83317H0.5V16.4998H15.5V8.1665H10.5ZM3.83333 14.8332H2.16667V13.1665H3.83333V14.8332ZM3.83333 11.4998H2.16667V9.83317H3.83333V11.4998ZM3.83333 8.1665H2.16667V6.49984H3.83333V8.1665ZM8.83333 14.8332H7.16667V13.1665H8.83333V14.8332ZM8.83333 11.4998H7.16667V9.83317H8.83333V11.4998ZM8.83333 8.1665H7.16667V6.49984H8.83333V8.1665ZM8.83333 4.83317H7.16667V3.1665H8.83333V4.83317ZM13.8333 14.8332H12.1667V13.1665H13.8333V14.8332ZM13.8333 11.4998H12.1667V9.83317H13.8333V11.4998Z" fill="currentColor"/>
    </svg>
  )
}

export default ORGicon;